import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import CreateIcon from "@mui/icons-material/Create";

//Srcs
import "../../Style/actionStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import GroupForm from "./GroupForm";
import DeleteForm from "../Include/DeleteForm";

import { DELETE_GROUP } from "../../Schema/Group";

export default function GroupAction({ editData, setRefetch }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //======================== delete =========================
  const [deleteGroup] = useMutation(DELETE_GROUP, {
    onCompleted: ({ deleteGroup }) => {
      // console.log("deleteGroup::", deleteGroup);
      setLoading(false);
      if (deleteGroup?.is_success === true) {
        setAlert(true, "success", deleteGroup?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteGroup?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteGroup({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("tooltip-update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <CreateIcon className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title={t("tooltip-delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <GroupForm
        dialogTitle="Update"
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />
      <DeleteForm
        open={openDel}
        handleClose={handleCloseDel}
        title="dialog_title_delete_group"
        confirmVal="Group"
        handleDelete={handleDelete}
      />
    </div>
  );
}
